import PhoneInput from '../components/PhoneInput/PhoneInput';
import PaymentDetails from '../components/PaymentDetails/PaymentDetails';
import { OpenVippsApp } from '../components/OpenVippsApp/OpenVippsApp';
import QrBlock from '../components/QrBlock/QrBlock';
import ContinueAsCard from '../components/ContinueAsCard/ContinueAsCard';
import { useLanguageContext } from '../core/locale/LanguageContext';
import type { InputViewChildProps } from './InputView.types';

const InputViewLegacy = ({
  merchant,
  claims,
  isQrEligible,
  isNoEdit,
  shouldShowPaymentDetails,
  initialMsisdn,
  error,
  loading,
  locale,
  shouldShowFancyDeeplinkButton,
  onSkippyClick,
  onSubmit,
  onUpdateCountry,
  initialRememberMe,
  initialNumberSource,
  showContinueAs,
  displayNumber,
  onContinueAs,
  onUseAnotherNumber,
}: InputViewChildProps): React.ReactNode => {
  const languageContext = useLanguageContext();
  return (
    <>
      <h1 className="visually-hidden">{languageContext.getLocalizedText('inputPrimaryLabel')}</h1>
      {shouldShowPaymentDetails && (
        <PaymentDetails
          showNewDesign={false}
          merchant={{
            companyName: merchant.companyName,
            displayName: merchant.displayName,
            logoUrl: merchant.logoUrl,
          }}
          title={claims.title}
          amount={{
            currency: claims.currency,
            value: claims.amount.toString(),
          }}
          locale={locale}
          paymentType={claims.paymentType}
        />
      )}
      {isQrEligible && <QrBlock />}
      {shouldShowFancyDeeplinkButton ?
        <OpenVippsApp onClick={onSkippyClick} />
      : showContinueAs ?
        <ContinueAsCard
          displayNumber={displayNumber}
          loading={loading}
          onContinue={onContinueAs}
          onUseAnotherNumber={onUseAnotherNumber}
        />
      : !claims.blockPhoneNumberInput && (
          <PhoneInput
            onSubmit={onSubmit}
            noEdit={isNoEdit}
            initialMsisdn={initialMsisdn}
            onUpdateCountry={onUpdateCountry}
            error={error}
            loading={loading}
            initialRememberMe={initialRememberMe}
            initialNumberSource={initialNumberSource}
          />
        )
      }
    </>
  );
};

export default InputViewLegacy;
